import { render, staticRenderFns } from "./ModalProduct.vue?vue&type=template&id=64771c57&scoped=true&"
import script from "./ModalProduct.vue?vue&type=script&lang=ts&"
export * from "./ModalProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ModalProduct.vue?vue&type=style&index=0&id=64771c57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64771c57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VChip,VContainer,VIcon,VImg,VSheet})
